import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AppShell } from '../../components/app-shell.tsx'

/** Cabinet pages: sidebar / icon rail / phone tab bar around them. */
export const Route = createFileRoute('/_authed/_shell')({
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
})
